import { createSelector } from 'reselect'

import { IFormState } from '../models'

export const createFormDataSelector = <T>(formKey: string) =>
  createSelector(
    (state: { form: IFormState<T> }) => state.form,
    (form) => form[formKey]
  )
